module.exports = __webpack_public_path__ + "static/HYDERABAD-512106f25ba715fdada3122c14913350.png";